/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const studentMessages: SegmentSpecificMessages = {
  emailExplanation: "A student email address is preferred",
  schoolName: "School",
  step: {
    personalInfo: {
      title: "Unlock this Student-Only Offer",
      subtitle: "Verify you're a student at a degree-granting school.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must currently be enrolled in a degree or certificate-granting, accredited school of education." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Birthdate",
        subtitle:
          "Your full name and birthdate must match what is on your official school records.",
      },
      verifyingTitle: "Verifying your student status",
      submitButtonText: "Verify My Student Status",
    },
    docUpload: {
      title: "To continue, upload documents that confirm your student status",
      uploadInstructions: "Upload your school-issued document that shows",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying students.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
    emailLoop: {
      errors: {
        invalidEmail:
          "This email address is not valid for instant verification. Please use an email address provided by your academic institution or upload documentation below.",
      },
      collectOrganizationEmail: {
        title: "Verify using your academic email address",
        subtitle:
          "Enter the email address provided by your academic institution and we'll send you a verification link",
        email: { label: "Academic email address" },
        alternative: "Unable to access an academic email address?",
      },
    },
    sso: {
      title: "Verify using academic institution credentials",
      subtitle:
        "Your academic institution's portal will open in a new window for you to verify using your login information",
      alternative: "You can also verify by uploading proof of your enrollment",
      login: "Sign into my academic institution",
      cancel: "Upload Proof of Enrollment",
    },
    reclaim: {
      title: "Verify using details from your academic institution",
      reclaimInfo: {
        consent:
          'By clicking "Verify my status" you consent to completing your verification using the SheerID Verifier.',
        login:
          "Your academic institution's portal will open on the next screen. Enter your login credentials to access the website.",
        display:
          "The SheerID Verifier will automatically identify personal information on the website needed to complete your verification and display it to you.",
        review:
          "You will have a chance to review the personal information and consent to share it with SheerID and its service providers.",
      },
      legal: {
        thirdPartyTools: "The SheerID Verifier uses third-party tools",
        thirdPartyToolsExplanation:
          "SheerID uses third-party tools to verify you. By proceeding, you agree to the use of these tools and to share your data with SheerID and its service providers to verify you.",
        secureLogin: "Secure login",
        secureLoginExplanation:
          "We keep your login details secure. SheerID and its service providers will not save or store them.",
        consent: "You consent and agree",
        consentExplanation:
          "By proceeding, you agree to use your own valid login credentials. You agree that your institution allows you to use third-party tools to access and collect information from its website. You consent to SheerID and its service providers collecting personal information from the website to verify you.",
        moreInformation: "More information",
        moreInformationExplanation:
          "To learn more about our privacy practices, including how we use service providers like SheerID and other partners to collect, use, store, and disclose you personal information, see our <privacyPolicy>privacy policy</privacyPolicy>.",
      },
      login: "Verify my status",
      cancel: "Verify another way",
    },
  },
};
